import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromState from '../reducers';
import { FooterActions } from '../actions';
import { Observable } from 'rxjs';
import * as FooterSelector from '../reducers/footer.reducer';
import { IFooter } from '../models/footer.models';

@Injectable({
  providedIn: 'root',
})
export class FooterFacade {

  constructor(
    private store: Store<fromState.State>,
  ) {
  }

  public dispatchFetchFooterNavigation() {
    this.store.dispatch(FooterActions.loadFooterNavigation());
  }

  public dispatchFetchSocialMediaFooter() {
    this.store.dispatch(FooterActions.loadSocialMediaFooter());
  }

  public selectFooterNavigation(): Observable<IFooter> {
    return this.store.select(FooterSelector.selectFooterNavigation);
  }

  public selectSocialMediaFooter(): Observable<IFooter> {
    return this.store.select(FooterSelector.selectSocialMediaFooter);
  }
}
